import { render, staticRenderFns } from "./wgbg.vue?vue&type=template&id=366de451&scoped=true&"
import script from "./wgbg.vue?vue&type=script&lang=js&"
export * from "./wgbg.vue?vue&type=script&lang=js&"
import style0 from "./wgbg.vue?vue&type=style&index=0&id=366de451&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366de451",
  null
  
)

export default component.exports